import React from 'react';
import HelpIcon from '../../Icons/HelpIcon/HelpIcon';
import './TextInput.css';

export interface TextInputProps {
	label: string;
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	disabled?: boolean;
	showInfoIcon?: boolean;
	tooltip?: string;
	className?: string;
	id?: string;
	required?: boolean;
	multiline?: boolean;
	rows?: number;
	ariaLabel?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
	label,
	value,
	onChange,
	placeholder,
	disabled = false,
	showInfoIcon = false,
	tooltip,
	className = '',
	id,
	required = false,
	multiline = false,
	rows = 4,
	ariaLabel,
}) => {
	const handleInputChange = (
		e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		if (!disabled) {
			onChange(e.target.value);
		}
	};

	return (
		<div className={`text-input-container ${className}`}>
			<div className="text-input-label-container">
				<label htmlFor={id} className="text-input-label">
					{label}
					{required && <span className="text-input-required-asterisk"> *</span>}
				</label>
				{showInfoIcon && <HelpIcon helpText={tooltip} className="text-input-help-icon" />}
			</div>
			<div className="text-input-field-container">
				{multiline ? (
					<textarea
						id={id}
						className="text-input-field text-input-textarea"
						value={value}
						onChange={handleInputChange}
						placeholder={placeholder}
						disabled={disabled}
						rows={rows}
						aria-label={ariaLabel}
					/>
				) : (
					<input
						id={id}
						type="text"
						className="text-input-field"
						value={value}
						onChange={handleInputChange}
						placeholder={placeholder}
						disabled={disabled}
						aria-label={ariaLabel}
					/>
				)}
			</div>
		</div>
	);
};
